import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "title is-4 is-spaced" }, "Payment Confirmed", -1)
const _hoisted_6 = { class: "title is-6 is-spaced" }
const _hoisted_7 = {
  key: 0,
  class: "columns"
}
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "title is-5 is-spaced has-text-danger" }
const _hoisted_10 = {
  key: 1,
  class: "columns"
}
const _hoisted_11 = { class: "column" }
const _hoisted_12 = ["href", "download"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_receipt_report = _resolveComponent("receipt-report")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h6", _hoisted_6, "Confirmation Number: " + _toDisplayString(_ctx.confirmationNumber), 1)
        ])
      ]),
      (_ctx.hasAttachments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.attachmentMessage), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isMobile())
      ? (_openBlock(), _createBlock(_component_receipt_report, {
          key: 0,
          id: _ctx.paymentCompleteStore.PaymentID
        }, null, 8, ["id"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              href: '/api/Report/DownloadReceiptReport?ID=' + _ctx.paymentCompleteStore.PaymentID,
              download: _ctx.confirmationNumber,
              class: "is-fullwidth-mobile button is-primary"
            }, "Download", 8, _hoisted_12)
          ])
        ]))
  ]))
}